import * as React from "react";
import { cn } from "../../lib/utils";
import { flexVariants } from "./constants";
import { FlexProps } from "./types";

const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
    ({ className, direction, align, justify, wrap, gap, ...props }, ref) => {
        return (
            <div
                className={cn(flexVariants({ direction, align, justify, wrap, gap }), className)}
                ref={ref}
                {...props}
            />
        );
    }
);
Flex.displayName = "Flex";

export { Flex, flexVariants }; 